
export type GetProjectById200BasicInfoVisibility = typeof GetProjectById200BasicInfoVisibility[keyof typeof GetProjectById200BasicInfoVisibility];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProjectById200BasicInfoVisibility = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
  LINK_ONLY: 'LINK_ONLY',
} as const;
